export {};
// export declare var XDomainRequest: {
//     prototype: IXDomainRequest;
//     new (): IXDomainRequest;
// };
//# sourceMappingURL=XDomainRequest.js.map